import { withTranslation } from "react-i18next"
import withRouter from "../../../../components/Common/withRouter"
import { useDispatch } from "react-redux"
import { useCallback, useState } from "react"
import { Card, CardBody, CardHeader, Col, Form, FormFeedback, Input, Label, Row } from "reactstrap"
import BreadCrumb from "../../../../components/Common/BreadCrumb"
import { Link, useNavigate } from "react-router-dom"
import { useFormik } from "formik"
import * as Yup from "yup";
import { saveDeductionCategory } from "../../../../slice/thunks"
import { toast } from "react-toastify";

const AddDeductionCategory = (props) => {

    const dispatch = useDispatch();
    const history = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const errorMesage = "Failed to save deduction category"

    const onClickOnSave = useCallback((values) => {
        setIsSubmitting(true);
        dispatch(saveDeductionCategory(values))
            .unwrap()
            .then((response) => {
                toast.success(response.message || "Deduction category saved successfully");
                history("/payroll/deduction-categories");
            })
            .catch((error) => {
                setIsSubmitting(false);
                toast.error(error.message || errorMesage);
            });

    }, [dispatch, setIsSubmitting, history])

    const addDeductionFormDef = useFormik({
        enableReinitialize: true,
        initialValues: {
            name: "",
            position: 1,
        },
        onSubmit: (values) => {
            onClickOnSave(values);
        },
        validationSchema: Yup.object({
            name: Yup.string().trim().required("Name of the category is required"),
            position: Yup.string()
                        .matches(/^[1-9]([0-9]?)+$/, "Rank must be a positive integer")
                        .required("Rank is required"),
        }),
        validateOnChange: true,
        validateOnBlur: true,
        validateOnMount: false,
        initialStatus: {
            isLoading: false,
            error: null,
            success: null
        }
    });

    return (
        <div className="deduction-categories px-3">
            <div className="patients-list py-4 px-2  ">
                <div className="container-fluid">
                    <div className="row list-patients d-flex  justify-content-between">
                        <Link to="/payroll/deduction-categories" className="col-lg-5">
                            <BreadCrumb title={props.t("deduction_categories")} pageTitle={props.t("add_deduction_category")} />
                        </Link>
                    </div>

                    <Card className="card table-card">
                        <CardHeader className="bg-light p-3">
                            <h5>{props.t("add_deduction_category")}</h5>
                        </CardHeader>
                        <CardBody>
                            <div className="container">
                                <Form
                                    className="tablelist-form"
                                    autoComplete="off"
                                    onSubmit={(e) => {
                                        e.preventDefault();
                                        addDeductionFormDef.handleSubmit();
                                        return false;
                                    }}
                                    >
                                        <Row>
                                            <Col md={12} sm={12}>
                                                <div className="mb-3">
                                                    <Label className="form-label">
                                                        Name of category
                                                        <span className="text-danger">*</span>
                                                    </Label>
                                                    <Input
                                                        name="name"
                                                        type="text"
                                                        value={addDeductionFormDef.values.name}
                                                        onChange={addDeductionFormDef.handleChange}
                                                        onBlur={addDeductionFormDef.handleBlur}
                                                        invalid={addDeductionFormDef.touched.name && !!addDeductionFormDef.errors.name}
                                                    />
                                                    <FormFeedback>
                                                        {addDeductionFormDef.errors.name}
                                                    </FormFeedback>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={12} sm={12}>
                                                <div className="mb-3">
                                                    <Label className="form-label">
                                                        Rank
                                                        <span className="text-danger">*</span>
                                                    </Label>
                                                    <Input
                                                        name="position"
                                                        type="text"
                                                        value={addDeductionFormDef.values.position}
                                                        onChange={addDeductionFormDef.handleChange}
                                                        onBlur={addDeductionFormDef.handleBlur}
                                                        invalid={addDeductionFormDef.touched.position && !!addDeductionFormDef.errors.position}
                                                    />
                                                    <FormFeedback>
                                                        {addDeductionFormDef.errors.position}
                                                    </FormFeedback>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row className="align-items-center p-3">
                                            <Col md={6} sm={12}>
                                                <div className="col-sm justify-content-start">
                                                    <span className="text-danger">
                                                        * : Required fields
                                                    </span>
                                                </div>
                                            </Col>
                                            <Col md={6} sm={12}>
                                                <div className="col-sm-auto">
                                                    <div className="hstack gap-2 justify-content-end">
                                                        <Link to="/payroll/deduction-categories" className="btn btn-std mx-2">
                                                            <i className="fas fa-times mx-1"></i>
                                                            {props.t("cancel")}
                                                        </Link>
                                                        <button
                                                            type="submit"
                                                            className="btn btn-std mx-2"
                                                            disabled={isSubmitting || !addDeductionFormDef.isValid}
                                                        >
                                                            <i className="fas fa-save mx-1"></i>
                                                            {props.t("save")}
                                                        </button>
                                                    </div>
                                                </div>
                                            </Col>

                                        </Row>
                                </Form>
                            </div>
                        </CardBody>
                    </Card>
                </div>
            </div>
        </div>
    );
}

export default withRouter(withTranslation()(AddDeductionCategory))